export enum ConstructionEndDateType {
    READY = 0,
    THREE_MONTHS = 3,
    SIX_MONTHS = 6,
    YEAR = 12,
    TWO_YEARS = 24,
    THREE_YEARS = 36
}

export const constructionEndDateName = (type: ConstructionEndDateType) => {
    switch (type) {
        case ConstructionEndDateType.READY:
            return "Gotowe";
        case ConstructionEndDateType.THREE_MONTHS:
            return "Do 3 miesięcy";
        case ConstructionEndDateType.SIX_MONTHS:
            return "Do 6 miesięcy";
        case ConstructionEndDateType.YEAR:
            return "Do roku";
        case ConstructionEndDateType.TWO_YEARS:
            return "Do 2 lat";
        case ConstructionEndDateType.THREE_YEARS:
            return "Do 3 lat";
        default:
            return "";
    }
};
export enum ConstructionEndDateType {
    READY = 0,
    THREE_MONTHS = 3,
    SIX_MONTHS = 6,
    YEAR = 12,
    TWO_YEARS = 24,
    THREE_YEARS = 36
}

export const constructionEndDateName = (type: ConstructionEndDateType) => {
    switch (type) {
        case ConstructionEndDateType.READY:
            return "Gotowe";
        case ConstructionEndDateType.THREE_MONTHS:
            return "Do 3 miesięcy";
        case ConstructionEndDateType.SIX_MONTHS:
            return "Do 6 miesięcy";
        case ConstructionEndDateType.YEAR:
            return "Do roku";
        case ConstructionEndDateType.TWO_YEARS:
            return "Do 2 lat";
        case ConstructionEndDateType.THREE_YEARS:
            return "Do 3 lat";
        default:
            return "";
    }
};
